import React from 'react';

import { ListItem, ListItemText, styled, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const ListItem_Styled = styled(ListItem)(({ theme }) => ({
  padding: 0,
  marginTop: 0,
  marginBottom: theme.spacing(4),
}));

const ListItemText_Styled = styled(ListItemText)(() => ({
  margin: 0,
}));

function DetailListItem({ label = '', detail }) {
  return (
    <ListItem_Styled>
      <ListItemText_Styled
        primary={
          <Typography component="div" variant="body">
            {label}
          </Typography>
        }
        secondaryTypographyProps={{ component: 'div' }}
        secondary={
          <ListItemText
            primary={
              <Typography component="span" variant="bodyLight">
                {detail}
              </Typography>
            }
          />
        }
      />
    </ListItem_Styled>
  );
}

DetailListItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  detail: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.string.isRequired]),
};

export default DetailListItem;
